import Dict from '@baifendian/adherev-util-dict';
export default {
    initStatic: function () {
        Dict.handlers.ResourceMomentFormat2 = function () { return 'YY'; };
        Dict.handlers.ResourceMomentFormat4 = function () { return 'YYYY'; };
        Dict.handlers.ResourceMomentFormat6 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "M");
                };
            };
        Dict.handlers.ResourceMomentFormat7 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "MM");
                };
            };
        Dict.handlers.ResourceMomentFormat8 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "M").concat(split, "D");
                };
            };
        Dict.handlers.ResourceMomentFormat10 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "MM").concat(split, "DD");
                };
            };
        Dict.handlers.ResourceMomentFormat13 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "M").concat(split1, "D H").concat(split2, "m").concat(split2, "s");
                };
            };
        Dict.handlers.ResourceMomentFormat15 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "MM").concat(split1, "DD H").concat(split2, "m").concat(split2, "s");
                };
            };
        Dict.handlers.ResourceMomentFormat16 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "M").concat(split1, "D HH").concat(split2, "mm").concat(split2, "ss");
                };
            };
        Dict.handlers.ResourceMomentFormat18 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "MM").concat(split1, "DD HH").concat(split2, "mm").concat(split2, "ss");
                };
            };
    },
};
